import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorDiff';

export class ColorDiff extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
